import { Directive, ElementRef, HostBinding, Input, HostListener, Optional } from '@angular/core';
import { BaseTrackingService } from '@app/tracking/base-tracking.service';
import { TrackingEvent } from '@app/models/tracking-event';
import { Constants } from '@app/common/constants';

@Directive({
  /* tslint:disable */
  selector: 'a:not([routerLink])'
  /* tslint:enable */
})
export class LinkDirective {

  constructor(
    @Optional() private trackingService: BaseTrackingService,
    private elementRef: ElementRef) {
  }

  @HostBinding('rel')
  @Input()
  rel = 'noopener';

  @HostBinding('target')
  @Input()
  target = '_blank';

  @HostListener('click')
  onClick() {
    if (this.trackingService) {
      const target = this.elementRef.nativeElement as HTMLElement;
      if (target) {
        const hrefAttribute = target.attributes.getNamedItem('href');
        const href = hrefAttribute ? hrefAttribute.value : null;
        const parentElement = this.getParentComponentElementThatStartWithPrefix(target, 'app-');
        const trackingEvent = new TrackingEvent({
          name: Constants.TRACKING_EVENT_TYPE_LINK_CLICK, properties: {
            href: href,
            componentId: parentElement.localName.toLowerCase()
          }
        });

        if (target.innerText && target.innerText !== '') {
          trackingEvent.properties.label = target.innerText;
        }

        this.trackingService.trackEvent(trackingEvent);
      }
    }
  }

  getParentComponentElementThatStartWithPrefix(el: HTMLElement, str: string) {
    if (el.localName.toLowerCase().startsWith(str.toLowerCase())) {
      return el;
    } else {
      return this.getParentComponentElementThatStartWithPrefix(el.parentElement, str);
    }
  }

}
